import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const DEMO_USERNAME = 'pruebas.coffeetest';
const DEMO_PASSWORD = 'CoffeeTest2026!';
const AUTH_URL = 'https://primeval-gear-417120.ue.r.appspot.com';

function ShopifyDemo() {
  const navigate = useNavigate();
  const [status, setStatus] = useState('Connecting your store...');

  useEffect(() => {
    let active = true;

    const runDemoLogin = async () => {
      try {
        setStatus('Setting up your demo...');

        const loginResponse = await fetch(`${AUTH_URL}/login`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            username: DEMO_USERNAME,
            password: DEMO_PASSWORD,
          }),
        });

        const loginData = await loginResponse.json();
        if (!loginResponse.ok || !loginData.access_token) {
          throw new Error(loginData.detail || 'Could not start demo session');
        }

        localStorage.setItem('token', loginData.access_token);
        if (loginData.refresh_token) {
          localStorage.setItem('refreshToken', loginData.refresh_token);
        }

        try {
          const protectedResponse = await fetch(`${AUTH_URL}/protected`, {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${loginData.access_token}`,
            },
          });

          if (protectedResponse.ok) {
            const protectedData = await protectedResponse.json();
            const projectId = protectedData?.company_info?.project_id || '';
            const datasetId = protectedData?.company_info?.database_name || '';
            if (projectId) {
              localStorage.setItem('projectId', projectId);
            }
            if (datasetId) {
              localStorage.setItem('datasetId', datasetId);
            }
          }
        } catch (syncError) {
          console.warn('Could not sync company info for demo:', syncError);
        }

        if (!active) return;
        setStatus('Redirecting to dashboard...');
        setTimeout(() => {
          window.location.href = '/';
        }, 700);
      } catch (error) {
        console.error('Shopify demo error:', error);
        if (!active) return;
        setStatus('Could not start demo. Redirecting to login...');
        setTimeout(() => {
          navigate('/');
        }, 1600);
      }
    };

    runDemoLogin();

    return () => {
      active = false;
    };
  }, [navigate]);

  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #F5F7FC 0%, #EAF6FF 45%, #F8F1E6 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
        padding: '24px',
      }}
    >
      <div
        style={{
          background: '#FFFFFF',
          borderRadius: '24px',
          padding: '44px 36px',
          width: '100%',
          maxWidth: '420px',
          textAlign: 'center',
          boxShadow: '0 24px 60px rgba(0, 45, 98, 0.12)',
        }}
      >
        <img
          src="https://upsellerate.ai/logo-upsellerate-transparent.png"
          alt="UPSELLerate"
          style={{ height: '48px', marginBottom: '20px' }}
        />
        <div
          style={{
            width: '44px',
            height: '44px',
            border: '3px solid #0B6B9B',
            borderTopColor: 'transparent',
            borderRadius: '50%',
            animation: 'spin 0.8s linear infinite',
            margin: '0 auto 18px',
          }}
        />
        <p style={{ color: '#334155', fontSize: '15px', margin: 0 }}>{status}</p>
        <style>{'@keyframes spin { to { transform: rotate(360deg); } }'}</style>
      </div>
    </div>
  );
}

export default ShopifyDemo;